import BaseSubGrid from "../../../Base/BaseSubGrid";

const keyName = 'RoutePreTrackGrid';

export default class RoutePreTrackGrid extends BaseSubGrid {
    constructor(props) {
        super(props);
        const context = this;
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        context.tableName = 'route_pretrack';
        context.idName = 'route_id';
        context.hiddenColumns = ['route_id', 'route_name', 'last_user', 'last_modified'];
        const labelWidth = '120px';
        context.columnsDefaults = [
            {column_name: 'pre_fst', row: 10, pos: 10, labelMinWidth: labelWidth, labelAlign: 'left', maxWidth: 50},
            {column_name: 'pre_fld', row: 20, pos: 20, labelMinWidth: labelWidth, labelAlign: 'left', maxWidth: 50},
            {column_name: 'pre_bog', row: 30, pos: 30, labelMinWidth: labelWidth, labelAlign: 'left', maxWidth: 50},
            {column_name: 'pre_all', row: 40, pos: 40, labelMinWidth: labelWidth, labelAlign: 'left', maxWidth: 50},
            {
                column_name: 'pre_path', hidden: true,
            },
            {
                column_name: 'pre_path_upload', hidden: true,
            },
        ];
        context.singleColumns = context.columnsDefaults;
    }
}

